<template>
  <div class="pool-balance">
    {{
      `${formatAmountDecimals(
        balance?.x as number,
        props.pool?.tokenEntities?.fromTokenEntity?.decimals,
      )}
                  ${props.pool?.tokenEntities?.fromTokenEntity?.symbol}`
    }}
  </div>
  <div class="pool-balance">
    {{
      `${formatAmountDecimals(
        balance?.y as number,
        props.pool?.tokenEntities?.toTokenEntity?.decimals,
      )}
                ${props.pool?.tokenEntities?.toTokenEntity?.symbol}
                `
    }}
  </div>
</template>
<script lang="ts" setup>
import { formatAmountDecimals } from '@/composables/usePoolsTableServices';
import { IPersistedPool, IPersistedTokenExtended } from '@/types/pools';

import { calcOutputBurnLiquidity } from '@/utils/contracts';
import { computed } from 'vue';

interface IProps {
  pool: IPersistedPool & {
    tokenEntities: {
      fromTokenEntity: IPersistedTokenExtended;
      toTokenEntity: IPersistedTokenExtended;
    };
  };
}

const props = defineProps<IProps>();

const balance = computed(() =>
  calcOutputBurnLiquidity({
    xReserve: props.pool.reserveX,
    yReserve: props.pool.reserveY,
    lpSupply: props.pool.lpTotal as number,
    toBurn: props.pool.lp,
  }),
);
</script>
